import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-outward-supervisor',
  templateUrl: './outward-supervisor.component.html',
  styleUrls: ['./outward-supervisor.component.css']
})
export class OutwardSupervisorComponent implements OnInit {

  constructor(private appComponent: AppComponent) { }

  ngOnInit(): void {
  }

}
